"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = exports.getEnvironment = exports.getEnvironmentTag = exports.isMobilePhone = exports.isTabletOrMobile = exports.mqlIsTabletOrMobile = exports.mqlIsMobilePhone = exports.replaceAuthDomain = exports.checkEmailPattern = exports.apiMap = void 0;
function getEnvironment() {
    var match = /(([\w]+)\.)?autopay\.io/.exec(location.hostname);
    if (!match) {
        if (IS_DEV_BUILD) {
            return 'local';
        }
        else {
            throw new Error('invalid location');
        }
    }
    if (match.length > 2 && match[2]) {
        var env = match[2];
        if (env === 'test' || env === 'qa') {
            return env;
        }
    }
    return 'prod';
}
exports.getEnvironment = getEnvironment;
function getEnvironmentTag() {
    var environment = getEnvironment();
    if (environment === 'local') {
        return '.test';
    }
    return environment === "prod" ? '' : ".".concat(environment);
}
exports.getEnvironmentTag = getEnvironmentTag;
function getDomain() {
    var environment = getEnvironment();
    if (environment === 'prod') {
        return 'autopay.io';
    }
    else if (environment === 'local') {
        return "test.autopay.io";
    }
    return "".concat(getEnvironment(), ".autopay.io");
}
exports.getDomain = getDomain;
function archiveApiUrl() {
    return "https://archive".concat(getEnvironmentTag(), ".autopay.io");
}
function selfServiceApiRunUrl() {
    return "https://selfservice-api-run".concat(getEnvironmentTag(), ".autopay.io");
}
function coreRunApiUrl() {
    return "https://core-run".concat(getEnvironmentTag(), ".autopay.io");
}
function tapNParkApiUrl() {
    return "https://tapnpark-api".concat(getEnvironmentTag(), ".autopay.io");
}
function bookingApiUrl() {
    return "https://booking-backend".concat(getEnvironmentTag(), ".autopay.io");
}
function bookingApplicationUrl() {
    return "https://booking".concat(getEnvironmentTag(), ".autopay.io");
}
function bookingClientApiUrl() {
    return "https://booking-client-api".concat(getEnvironmentTag(), ".autopay.io");
}
function m2mApplicationApiUrl() {
    return "https://api-auth".concat(getEnvironmentTag(), ".autopay.io");
}
function apiUrl() {
    return "https://api".concat(getEnvironmentTag(), ".autopay.io");
}
function authServerUrl() {
    return "https://auth".concat(getEnvironmentTag(), ".autopay.io");
}
function cmsUrl() {
    return "https://cms1".concat(getEnvironmentTag(), ".autopay.io");
}
var apiMap = {
    root: selfServiceApiRunUrl(),
    rootRun: selfServiceApiRunUrl(),
    users: "".concat(selfServiceApiRunUrl(), "/users"),
    permits: "".concat(selfServiceApiRunUrl(), "/permits"),
    sessions: "".concat(selfServiceApiRunUrl(), "/sessions"),
    search: "".concat(selfServiceApiRunUrl(), "/search"),
    payments: "".concat(selfServiceApiRunUrl(), "/payments"),
    'external-profiles': "".concat(selfServiceApiRunUrl(), "/external-profiles"),
    avinor: "".concat(selfServiceApiRunUrl(), "/avinor-profiles"),
    authorization: "".concat(selfServiceApiRunUrl(), "/authorization"),
    organizations: "".concat(selfServiceApiRunUrl(), "/organizations"),
    tapNPark: "".concat(tapNParkApiUrl(), "/tnp"),
    booking: "".concat(bookingApiUrl(), "/booking"),
    bookingClient: "".concat(bookingClientApiUrl()),
    bookingApplication: "".concat(bookingApplicationUrl()),
    analytics: "".concat(selfServiceApiRunUrl(), "/analytics"),
    notifications: "".concat(selfServiceApiRunUrl(), "/notifications"),
    notificationCenter: "".concat(selfServiceApiRunUrl(), "/notification-center"),
    archive: "".concat(archiveApiUrl(), "/archive"),
    hardware: "".concat(coreRunApiUrl(), "/hardware"),
    locations: "".concat(coreRunApiUrl(), "/locations"),
    accounting: "".concat(apiUrl(), "/accounting"),
    status: "".concat(apiUrl(), "/status"),
    vehicle: "".concat(coreRunApiUrl(), "/vehicle"),
    receipt: "".concat(coreRunApiUrl(), "/receipt"),
    priceCalculator: "".concat(coreRunApiUrl(), "/price-calculator"),
    m2m: m2mApplicationApiUrl(),
    invoicing: "".concat(coreRunApiUrl(), "/invoicing"),
    authServer: authServerUrl(),
    customerService: "".concat(selfServiceApiRunUrl(), "/customer-service"),
    manualSessions: "".concat(coreRunApiUrl(), "/manual-sessions"),
    screen: "".concat(coreRunApiUrl(), "/screen"),
    parkings: "".concat(coreRunApiUrl(), "/parkings"),
    fleet: "".concat(coreRunApiUrl(), "/fleet"),
    webpages: cmsUrl(),
    customerClub: "".concat(selfServiceApiRunUrl(), "/customer-club"),
    plateCorrections: "".concat(coreRunApiUrl(), "/plate-corrections"),
};
exports.apiMap = apiMap;
if (IS_DEV_BUILD && SELF_SERVICE_API_OVERRIDES) {
    exports.apiMap = apiMap = __assign(__assign({}, apiMap), SELF_SERVICE_API_OVERRIDES);
}
function checkEmailPattern(email) {
    /* tslint:disable-next-line: max-line-length */
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}
exports.checkEmailPattern = checkEmailPattern;
function replaceAuthDomain(firebaseInitJson) {
    if (IS_DEV_BUILD) {
        return __assign(__assign({}, firebaseInitJson), { authDomain: 'test.autopay.io' });
    }
    else {
        return __assign(__assign({}, firebaseInitJson), { authDomain: window.location.hostname });
    }
}
exports.replaceAuthDomain = replaceAuthDomain;
// Copied the value from @tabletxl in autopay.io/style.
var mqlIsTabletOrMobile = window.matchMedia("only screen and (max-width: 1030px)");
exports.mqlIsTabletOrMobile = mqlIsTabletOrMobile;
// Same as old 'isMobile()'
function isTabletOrMobile() {
    return mqlIsTabletOrMobile.matches;
}
exports.isTabletOrMobile = isTabletOrMobile;
// Copied the value from @mobilexl in autopay.io/style.
var mqlIsMobilePhone = window.matchMedia("only screen and (max-width: 600px)");
exports.mqlIsMobilePhone = mqlIsMobilePhone;
function isMobilePhone() {
    return mqlIsMobilePhone.matches;
}
exports.isMobilePhone = isMobilePhone;
